import React, {useEffect, useState} from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import Secondary from "./secondary"
import {debounce} from "../functions";
import {useIntl} from "gatsby-plugin-react-intl"
import SearchInput from "../common/searchInput"
import { generateUrlForStaticPages } from "../../services/intl.service";
import StyledButton from "../common/styledButton";
import HotelFlightLink from "../common/hotelFlightLink";

import BookButton from "../Header/button";
import PlanYourStay from "../common/planYourStayLink";

const MainMenu = ({ menus, locale }) => {

  const intl = useIntl()
  const data = useStaticQuery(graphql`
  query ButtonMobileQuery {
    upperFooterMenuEn: allMenuLinkContentUpperFooter(
      filter: {
        enabled: { eq: true }
        title: { ne: "Dummy" }
        langcode: { eq: "en" }
      }
      sort: { fields: weight, order: ASC }
    ) {
      ...upperFooterMenuFields
    }
    upperFooterMenuFr: allMenuLinkContentUpperFooter(
      filter: {
        enabled: { eq: true }
        title: { ne: "Dummy" }
        langcode: { eq: "fr" }
      }
      sort: { fields: weight, order: ASC }
    ) {
      ...upperFooterMenuFields
    }
  }
`)

let upperFooterMenu

// Get footer data by locale
switch (locale) {
  case "fr":
    if (data.upperFooterMenuFr && data.upperFooterMenuFr.nodes) {
      upperFooterMenu = data.upperFooterMenuFr.nodes
    }
    break
  default:
    if (data.upperFooterMenuEn && data.upperFooterMenuEn.nodes) {
      upperFooterMenu = data.upperFooterMenuEn.nodes
    }
}
  const breakpoint = 1025

  const [screen, setMobile] = useState({
    isMobile: typeof window !== `undefined` && window.innerWidth < breakpoint,
  })

  const [isClient, setClient] = useState(false)

  useEffect(() => {
    setClient(true)

    const debouncedHandleResize = debounce(function handleResize() {
      setMobile({
        isMobile:
          typeof window !== `undefined` && window.innerWidth < breakpoint,
      })
    }, 200)

    if (typeof window !== `undefined`) {
      window.addEventListener("resize", debouncedHandleResize)
    }
  }, [])

  return (
    <nav>
      {/*{isClient && screen.isMobile ? (*/}
      {/*  <div className="searchMob">*/}
      {/*    <SearchInput />*/}
      {/*  </div>*/}
      {/*) : (*/}
      {/*  <></>*/}
      {/*)}*/}
      <ul className="mainMenu">
        {menus.map(menu => {
          return (
            <li key={menu.drupal_id}>
              {menu.childNodes.length > 0 ? (
                <Secondary menu={menu} />
              ) : (
                <Link to={generateUrlForStaticPages(menu.langcode, menu.link.url)}>{menu.title}</Link>
              )}
            </li>
          )
        })}
        {isClient && screen.isMobile ? (
          <>
            <li>
            <PlanYourStay locale={locale}/>
          </li>
            {upperFooterMenu.length > 0 &&
              upperFooterMenu.map((menu, index) => {
                return (
                  <li key={index} className="btnMobMenu">
                    <StyledButton 
                      type="transparent" 
                      title={menu.title} 
                      key={index} 
                      path={generateUrlForStaticPages(
                        menu.langcode,
                        menu.link.url
                      )}
                    />
                  </li>
                )
              })
          }
          <li className="btnMobMenu">
            <HotelFlightLink
                locale={locale}
            />
          </li>
         
          </>
        ) : (
          <></>
        )}
      </ul>
    </nav>
  )
}

export default MainMenu
